import { createAction } from '@poa/state';

// fetching
export const fetchGifts = createAction('gifts/fetch', () => ({}));
export const refreshGifts = createAction('gifts/refresh', (filters = [], page = 1) => ({
  filters,
  page
}));
export const fetchGiftsSuccess = createAction('gifts/fetchSuccess', data => ({ data }));
export const fetchGiftsFailed = createAction('gifts/fetchFailed', () => ({}));

// filters
// grouping
export const changeGrouping = createAction('gifts/changeGrouping', grouping => ({
  grouping
}));
export const changeFilter = createAction('gifts/changeFilter', filter => ({ filter }));
export const resetGrouping = createAction('gifts/resetGrouping', grouping => ({ grouping }));
